import { parsePressure, parseLength } from "../../utils/units.js";

class ConcreteDialogComponent extends HTMLElement {

  designType = 'ACI Chapter 9'
  highSeismicZone = false
  concreteStrength = '4' // ksi
  concreteThickness = '15' // in

  constructor() {
    super()
    document.addEventListener('project-loaded', async (event) => this.onProjectLoaded(event.detail.concrete), true)
    this.addEventListener('show.bs.modal', this.configure)
  }

  /**
   * Create our view model and configure the view
   * @param {Concrete} model
   * 
   */
   onProjectLoaded(model) {
    this.designType = model.designType
    this.highSeismicZone = model.highSeismicZone
    this.concreteStrength = `${model.concreteStrength}`
    this.concreteThickness = `${model.concreteThickness}`
    //this.configure()
    //this.publishUpdate()
  }

  configure() {
    document.getElementById('aci-chapter-9-button').checked = this.designType === 'ACI Chapter 9'
    document.getElementById('aci-appendix-c-button').checked = this.designType === 'ACI Appendix C'
    document.getElementById('category-c').checked = this.highSeismicZone
    document.getElementById('concrete-strength-input').value = this.concreteStrength
    document.getElementById('concrete-thickness-input').value = this.concreteThickness
  }

  publishUpdate() {
    const event = new CustomEvent('concrete-dialog-update', { detail: this });
    this.dispatchEvent(event)
  }

  onDesignTypeClick(designStr) {
    this.designType = designStr
    this.publishUpdate()
  }

  onCategoryCClick() {
    this.highSeismicZone = document.getElementById('category-c').checked
    this.publishUpdate()
  }

  onConcreteStrengthBlur() {
    const value = parsePressure(document.getElementById("concrete-strength-input").value)
    if(isNaN(value) || value <= 0) {
      document.getElementById('concrete-strength-validation').classList.remove('d-none')
      return
    }
    document.getElementById('concrete-strength-validation').classList.add('d-none') 
    this.concreteStrength = document.getElementById('concrete-strength-input').value
    this.publishUpdate()
  }
    
  onConcreteThicknessBlur() {
    const value = parseLength(document.getElementById("concrete-thickness-input").value)
    if(isNaN(value) || value <= 0) {
      document.getElementById('concrete-thickness-validation').classList.remove('d-none')
      return
    }
    document.getElementById('concrete-thickness-validation').classList.add('d-none') 
    this.concreteThickness = document.getElementById('concrete-thickness-input').value
    this.publishUpdate()
  }


  connectedCallback() {
    this.innerHTML = String.raw`
    <div class="modal fade" id="modal-concrete-dialog" tabindex="-1" role="dialog" aria-labelledby="myModalShapeLabel"
      aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Specify Concrete</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="bs-component">
              <!-- Table -->
              <form id="concrete-form">
                <div>
                  <p><strong>1. Select Load Factors</strong></p>
                  <div class="btn-group btn-group-sm" id="design-type-radio-group" role="group"
                    style="margin:10px 0px 10px 0px;" aria-label="Design type toggle button group">
                    <input type="radio" class="btn-check" name="design-type-radio" id="aci-chapter-9-button"
                      autocomplete="off" checked>
                    <label class="btn btn-outline-secondary" for="aci-chapter-9-button">ACI Chapter 9</label>
                    <input type="radio" class="btn-check" name="design-type-radio" id="aci-appendix-c-button"
                      autocomplete="off">
                    <label class="btn btn-outline-secondary" for="aci-appendix-c-button">ACI Appendix C</label>
                  </div>
                  <div style="margin:10px 0px 10px 0px;">
                    <label><input type="checkbox" id="category-c"> 
                    SeismicDesign Category "C" or Higher</label>
                  </div>
                </div>
                <div>
                  <p><strong>2. Specify Concrete Strength</strong></p>
                  <table class="table">
                    <tr>
                      <td style="width:120px;">F'c (ksi)</td>
                      <td>
                        <input style="width:100px;" id="concrete-strength-input" type="text" name="concrete-strength"
                        class="text-center" value="${this.concreteStrength} ksi" />
                        <div  style="width:200px;" id="concrete-strength-validation" class="alert alert-danger d-none">
                          Please enter a valid concrete strength. e.g. 4 or 4 ksi
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
                <div id="bolt-size-selector">
                  <p><strong>3. Specify Concrete Thickness</strong></p>
                  <table class="table">
                    <tr>
                      <td style="width:120px;">Thickness (in)</td>
                      <td>
                        <input style="width:100px;" id="concrete-thickness-input" type="text" name="concrete-thickness"
                        class="text-center" value="${this.concreteThickness} in" />
                        <div  style="width:200px;" id="concrete-thickness-validation" class="alert alert-danger d-none">
                          Please enter a valid thickness. e.g. 15 or 15"
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>`

    var radios = document.getElementById('design-type-radio-group').getElementsByTagName('input');
    for (const radio of radios) {
      let selector = 'label[for=' + radio.id + ']';
      const labelStr = document.querySelector(selector).innerHTML;
      radio.onclick = function () {
        this.onDesignTypeClick(labelStr)
      }.bind(this)
    }

    document.getElementById('concrete-strength-input').onblur = (() => this.onConcreteStrengthBlur())
    document.getElementById('concrete-thickness-input').onblur = (() => this.onConcreteThicknessBlur())
    document.getElementById('category-c').onclick = (() => this.onCategoryCClick())

    this.configure()
  }
}

customElements.define('concrete-dialog-component', ConcreteDialogComponent)













